module.exports = __webpack_public_path__ + "img/buzou.72e33cfa.png";